import GooglePlaceAutoComplete from '../services/GooglePlaceAutoComplete';

window.BlazorInitPlaceAutoComplete = function () {
    let streetAddressInput = document.getElementById("street-adress");
    new GooglePlaceAutoComplete(streetAddressInput, BlazorOnPlaceChanged);
}


window.BlazorOnPlaceChanged = function (place) {

    let streetNumber;
    let streetAddress;
    const changeEvent = new Event('change');

    for (const component of place.place.address_components) {
        // @ts-ignore remove once typings fixed
        const componentType = component.types[0];

        switch (componentType) {

            case "street_number": {
                streetNumber = component.long_name;
                break;
            }

            case "route": {
                streetAddress = component.short_name;
                break;
            }

            case "postal_code": {
                document.getElementById("postal-code").value = component.long_name;
                document.getElementById("postal-code").dispatchEvent(changeEvent);
                break;
            }
            case "postal_town": {
                document.getElementById("city").value = component.long_name;
                document.getElementById("city").dispatchEvent(changeEvent);
                break;
            }
            case "country":
                const countryComponent = component.types.includes("country");
                const coountryElement = document.querySelector("#country");
                if (countryComponent && coountryElement != null) {
                    document.querySelector("#country").value = component.short_name;
                }
                break;
        }
    }

    document.getElementById("street-adress").value = `${streetAddress} ${streetNumber ?? ""}`;
    document.getElementById("street-adress").dispatchEvent(changeEvent);
}
